import immutable from 'immutable';
import {
  GET_PROFILE_FAIL,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  SET_PROFILE_MEASUREMENT_FORMAT
} from './action';
import {
  STATE_PROP,
  MEASUREMENT_FORMAT_STORAGE_KEY,
  MEASUREMENT_FORMAT
} from './util/constant';

export const init = () => {
  const initValue = immutable.fromJS({
    profile: undefined
  });

  const localStorageMeasurementFormat =
    localStorage.getItem(MEASUREMENT_FORMAT_STORAGE_KEY) ||
    MEASUREMENT_FORMAT.METRIC;

  return initValue.set(STATE_PROP, {
    displayName: '',
    organization: '',
    phoneNumber: '',
    preferredLanguage: '',
    [MEASUREMENT_FORMAT_STORAGE_KEY]: localStorageMeasurementFormat
  });
};

export default function profileReducer(state = init(), action) {
  const { payload } = action;
  switch (action.type) {
    case GET_PROFILE_REQUEST:
      return state.update(STATE_PROP, (profile) => ({
        ...profile,
        isLoading: true
      }));

    case GET_PROFILE_SUCCESS: {
      return state.update(STATE_PROP, (profile) => {
        return {
          ...profile,
          ...payload,
          isLoading: false
        };
      });
    }

    case GET_PROFILE_FAIL:
      return state.update(STATE_PROP, (profile) => ({
        ...profile,
        isLoading: false
      }));

    case SET_PROFILE_MEASUREMENT_FORMAT: {
      localStorage.setItem(MEASUREMENT_FORMAT_STORAGE_KEY, payload);

      return state.update(STATE_PROP, (profile) => ({
        ...profile,
        [MEASUREMENT_FORMAT_STORAGE_KEY]: payload
      }));
    }

    default:
      return state;
  }
}
